import {Button, Grid, Icon, Stack, Text} from "@mbank-design/design-system/components";
import {PencilColor, Plus} from "@mbank-design/design-system/icons";
import React, {useCallback, useContext} from "react";
import SpeakerSection from "./SpeakerSection";
import {SpeakersContext} from "./SpeakersContext";
import {
    createDefaultValidationAction,
    INPUT_CHANGED_ACTION,
    ValidationContextDispatch
} from "../SpeakerInvitationValidation";

export default function  Speakers() {
    const { speakers, onAddSpeaker } = useContext(SpeakersContext);
    const validationDispatch = useContext(ValidationContextDispatch);
    
    if (!speakers || speakers.length === 0)
        return (<></>);

    const validateForm = () => {
        validationDispatch!({
            ...createDefaultValidationAction(),
            type: INPUT_CHANGED_ACTION,
            speakers
        });
    };
    
    return (
        <Stack>
            <Text as="h2">your details</Text>
            <Grid>
                <Grid.Row>
                    <Grid.Column span={1}>
                        <Icon iconComponent={PencilColor} size={24}/>
                    </Grid.Column>
                    <Grid.Column span={11}>
                        <Text fontFamily="Montserrat">please fill in this form to register for the event</Text>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            {speakers!.map(s  => (
                <SpeakerSection key={s.uiId} speaker={s} validateForm={validateForm} />)
            )}
            <Button buttonType={"tertiary"} iconComponent={Plus} onClick={onAddSpeaker}>add next person</Button>
        </Stack>
    );
}